import { getResidualRiskLevels, ResidualRiskLevel } from "@/redux/account.types"

/**
 * Match value with the sacle
 */
export function getRiskResidualUi(value: number, values: number[], levels?: ResidualRiskLevel[]) {
  const thresholds = Array.isArray(values) && values.length ? values : [4, 16, 40]
  const index = thresholds.filter((t) => value >= t).length
  const residualLevels = getResidualRiskLevels({ residualRiskScale: thresholds, residualRiskLevels: levels })
  const scale = residualLevels[index]
  if (!scale) {
    return { color: residualLevels[0].color, label: "Non calculé", index }
  }
  return { color: scale.color, label: scale.label, index }
}
